import { Box, MenuItem, Select, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import DataListingComponent from "../../Component/DataListingComponent";
import { API_endspoints } from "../../API/API_endspoints";
import { API_GET } from "../../API/config";

const PAGE_SIZE_OPTIONS = [15];

const NewsLetterManagement = () => {
  const [data, setData] = useState([]);
  const [IsLoading, setIsLoading] = useState(true);
  const [totalData, setTotalData] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);
  const [selectedStatus, setSelectedStatus] = useState("");

  const column = [
    {
      headerClassName: "super-app-theme--header",
      field: "rowid",
      headerName: "Sr.",
      width: 100,
      headerAlign: "center",
      renderCell: (params) => params.row.rowid + page * rowsPerPage,
    },
    {
      headerClassName: "super-app-theme--header",
      field: "type",
      headerName: "Type",
      width: 250,
      headerAlign: "center",
      renderCell: (cell) =>
        cell?.row?.type === 1 ? "Customer" : cell?.row?.type === 2 && "Company",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "email",
      headerName: "Email",
      flex: 1,
      headerAlign: "center",
    },
  ];

  const handlePageChange = (e, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const getData = async (
    page = 0,
    pageSize = PAGE_SIZE_OPTIONS[0],
    status = "",
    statusRef = ""
  ) => {
    try {
      setIsLoading(true);
      let newPage = page;

      if (status !== statusRef) {
        newPage = 0;
        setPage(0);
      }

      let queryParams = new URLSearchParams({
        count: newPage * pageSize,
        offset: pageSize,
      });

      if (status !== "") {
        queryParams.append("type", status);
      }

      const api = `${
        API_endspoints.getSubscribedNewsLetter
      }?${queryParams.toString()}`;
      let res = await API_GET(api);
      const Rowdata = res?.r?.map((data, i) => ({
        rowid: i + 1,
        ...data,
      }));
      if (res?.r?.length > 0) {
        setData(Rowdata);
        setTotalData(res?.c ?? 0);
      } else {
        setData([]);
        setTotalData(0);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const handleStatusChange = (event) => {
    const status = event.target.value;
    setSelectedStatus(status);
  };
  const statusRef = useRef(selectedStatus);

  useEffect(() => {
    getData(page, rowsPerPage, selectedStatus, statusRef.current);
    statusRef.current = selectedStatus;
  }, [page, rowsPerPage, selectedStatus]);

  return (
    <Box sx={{ height: "calc(100vh - 32px)" }}>
      <Box
        sx={{
          height: "110px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          width: "100%",
          background: "#ffffff",
          borderBottom: "1px solid #CED7E4",
        }}
      >
        <Typography
          sx={{
            fontSize: "26px",
            fontWeight: 500,
          }}
        >
          News Letter Management
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1, // Adds spacing between label and dropdown
          }}
        >
          {/* <Typography
                        sx={{
                            fontSize: "16px",    // Smaller font for the label
                            fontWeight: 500,     // Medium weight to differentiate from the title
                            color: "#555",       // Softer color for the label
                            marginRight: "8px",  // Spacing between label and Select
                        }}
                    >
                        Status
                    </Typography> */}
          <Select
            value={selectedStatus}
            onChange={handleStatusChange}
            displayEmpty
            size="small"
            sx={{
              minWidth: 150, 
              padding: "8px 12px",
              fontSize: "14px",
              borderRadius: "8px", 
              border: "1px solid #CED7E4", 
              backgroundColor: "#F9F9F9", 
              "&:hover": {
                backgroundColor: "#F0F0F0",
              },
            }}
          >
            {[
              { key: "", value: "All" },
              { key: 1, value: "Customer" },
              { key: 2, value: "Company" },
            ].map((option) => (
              <MenuItem key={option.key} value={option.key}>
                {option.value}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>

      <Box
        sx={{
          background: "#F4F4F4",
          height: "calc(100% - 130px)",
          width: "100%",
          p: 2,
        }}
      >
        <DataListingComponent
          data={data ?? []}
          PAGE_SIZE_OPTIONS={PAGE_SIZE_OPTIONS}
          loading={IsLoading}
          totalData={totalData}
          page={page}
          Footer={true}
          columns={column}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          handleRowsPerPageChange={handleRowsPerPageChange}
        />
        {/* <BookingDetailsModal open={open} setOpen={setOpen} data={modalData} /> */}
      </Box>
    </Box>
  );
};

export default NewsLetterManagement;
